import styled from "styled-components";
import { Modal } from "components/Modal";

export const TransferFundsModalContainer = styled(Modal)`
  .modal-dialog {
    max-width: 609px;

    .modal-content {
      padding: 0;

      .modal-body {
        padding: 0;
        margin-top: 0;

        .modal-header {
          padding: 20px 24px;
          border-bottom: 1px solid ${({ theme }) => theme.input.border.color};

          .modal-title {
            margin: 0;
            font-size: 20px;
            font-weight: 500;
            color: ${({ theme }) => theme.card.font.tertiary};
          }
        }

        .modal-body-content {
          padding: 24px;

          .loader-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 200px;
          }

          .account-header {
            display: flex;
            justify-content: center;
            margin-bottom: 24px;

            .account-avatar {
              .account-avatar-img {
                width: 64px;
                height: 64px;
              }
            }
          }

          .divider {
            height: 1px;
            background-color: ${({ theme }) => theme.input.border.color};
            margin: 24px 0;
          }

          .transfer-section {
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-radius: 8px;
            cursor: pointer;
            transition: all 0.2s ease;
            margin-bottom: 12px;

            &:last-child {
              margin-bottom: 0;
            }

            .transfer-section-left {
              display: flex;
              align-items: center;
              gap: 16px;
              flex: 1;

              .transfer-icon {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 48px;
                height: 48px;
                border-radius: 8px;
                background-color: ${({ theme }) =>
                  theme.aside.bg.secondary || "#f5f5f5"};
              }

              .transfer-content {
                flex: 1;

                .transfer-title {
                  margin: 0 0 4px 0;
                  font-size: 16px;
                  font-weight: 500;
                  color: ${({ theme }) => theme.card.font.tertiary};
                }

                .transfer-description {
                  margin: 0;
                  font-size: 14px;
                  color: ${({ theme }) => theme.card.font.secondary};
                  line-height: 1.4;
                }
              }
            }

            .transfer-section-right {
              display: flex;
              align-items: center;
              margin-left: 16px;
            }
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    .modal-dialog {
      max-width: 100%;
      margin: 0 16px;

      .modal-content {
        .modal-body {
          .modal-header {
            padding: 16px 20px;

            .modal-title {
              font-size: 18px;
            }
          }

          .modal-body-content {
            padding: 20px;

            .transfer-section {
              padding: 12px;

              .transfer-section-left {
                gap: 12px;

                .transfer-icon {
                  width: 40px;
                  height: 40px;
                }

                .transfer-content {
                  .transfer-title {
                    font-size: 15px;
                  }

                  .transfer-description {
                    font-size: 13px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
